import { render } from "./InputPassword.vue?vue&type=template&id=56f5b462"
import script from "./InputPassword.vue?vue&type=script&lang=js"
export * from "./InputPassword.vue?vue&type=script&lang=js"
script.render = render

export default script